import { IScheduleWbsTemplate } from '../../interfaces/ischedule-wbs-template';
import { ScheduleTemplateName } from '../schedule-template-name';

export class ScheduleWbsTemplateBase {
  ScheduleWbsTemplateId: number;
  ScheduleTemplateNameId: number;
  ScheduleWbsId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ScheduleTemplateName?: ScheduleTemplateName;

  constructor(item?: IScheduleWbsTemplate) {
    if (item) {

      this.ScheduleWbsTemplateId = item.ScheduleWbsTemplateId;
      this.ScheduleTemplateNameId = item.ScheduleTemplateNameId;
      this.ScheduleWbsId = item.ScheduleWbsId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ScheduleTemplateName = new ScheduleTemplateName(item.ScheduleTemplateName);
    }
  }
}